import React, {useContext, useState, useEffect} from 'react';
import { useTheme, Typography, makeStyles, Button, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import globalContext from '../context/globalContext';
import ProgressButton from '../components/progressButton';
import Alert from '@material-ui/lab/Alert';
import API from '../global/api';

const useStyles = makeStyles(theme => ({
    container: {},
    inner: {},
}));

const TariffDelete = props => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const context = useContext(globalContext)

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const handleRemove = async () => {

        try {
            setLoading(true);
            setError(null);

            //
            // Execute an api request and get the returned result
            //
            API.req(`/tariff/${context.profile.data.id_organisation}`, 'DELETE', props.form).then(
                async res => {
                setLoading(false);
        
                context.tariffUpdate(res.result);
        
                if(typeof props.handleSuccess === 'function')
                    props.handleSuccess();
        
                context.showSnack({message: 'Tariff deleted!'}, 'success')
        
                },
                err => {
                    setLoading(false);
                    setError(typeof err === 'string' ? err : JSON.stringify(err))
                }
            )
        
        } catch (err) {
            setError(typeof err === 'string' ? err : JSON.stringify(err))
        } finally {
            setLoading(false);
        }


    }

    const handleClose = () => {
        if(typeof props.handleClose === 'function')
            props.handleClose();
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="remove-rfid" open={true} maxWidth="xs">
            <DialogTitle id="remove-rfid-title">Delete tariff</DialogTitle>
            <DialogContent>
                {error && <Alert severity="error">{error}</Alert>}
                
                <Typography variant="body2">Are you sure you want to delete this tariff?</Typography>
                
                <div className="flex-row space-between mt">
                    <Button onClick={handleClose}>Cancel</Button>
                    <ProgressButton waiting={loading} color="secondary" variant="contained" onClick={handleRemove}>Delete</ProgressButton>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default TariffDelete;